// Upload type policy for the vault upload flow. The allowed MIME list normally comes
// from OnlyFans' /init response (postMediaConfig.extensions); this fallback applies
// before that has loaded. HEIC/HEIF upload untouched — OnlyFans converts them server-side.
export const FALLBACK_UPLOAD_TYPES = [
    'image/jpeg',
    'image/jpg',
    'image/png',
    'image/gif',
    'image/webp',
    'image/heic',
    'image/heif',
    'video/mp4',
    'video/quicktime',
    'video/x-msvideo',
    'video/webm',
    'audio/mpeg',
    'audio/mp3',
    'audio/wav',
    'audio/ogg',
];

// Windows has no registered MIME type for HEIC/HEIF, so browsers there report an empty
// file.type and the type must be resolved from the extension instead.
const EXTENSION_MIME_TYPES: Record<string, string> = {
    heic: 'image/heic',
    heif: 'image/heif',
};

// OnlyFans' converter accepts HEIC/HEIF regardless of whether a given /init payload
// lists their MIME strings, so the allowed list must always include them — otherwise
// the picker greys HEIC files out whenever the dynamic init list omits them.
export const withHeicUploadTypes = (allowedTypes: string[]): string[] => {
    const missing = Object.values(EXTENSION_MIME_TYPES).filter(mimeType => !allowedTypes.includes(mimeType));
    return missing.length > 0 ? [...allowedTypes, ...missing] : allowedTypes;
};

export const resolveUploadMimeType = (file: File): string => {
    if (file.type) {
        return file.type;
    }
    const extension = file.name.split('.').pop()?.toLowerCase() ?? '';
    return EXTENSION_MIME_TYPES[extension] ?? '';
};

export const isAllowedUploadFile = (file: File, allowedTypes: string[]): boolean => {
    return allowedTypes.includes(resolveUploadMimeType(file));
};

export const buildUploadAcceptAttr = (allowedTypes: string[]): string => {
    const extensions = Object.entries(EXTENSION_MIME_TYPES)
        .filter(([, mimeType]) => allowedTypes.includes(mimeType))
        .map(([extension]) => `.${extension}`);
    return [...allowedTypes, ...extensions].join(',');
};
